import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiSend, FiPlay } = FiIcons;

const Contact = ({ pageHeading = false }) => {
  const handleSubmit = (e) => {
    e.preventDefault();
    const formData = new FormData(e.currentTarget);
    const name = formData.get('name');
    const email = formData.get('email');
    const subject = formData.get('subject');
    const message = formData.get('message');
    
    const mailtoLink = `mailto:sandstormflix@gmail.com?subject=${encodeURIComponent(subject + ' - ' + name)}&body=${encodeURIComponent("From: " + name + " (" + email + ")\n\n" + message)}`;
    window.location.href = mailtoLink;
  };

  const Heading = pageHeading ? 'h1' : 'h2';

  return (
    <section className="bg-black py-24 overflow-hidden" id="contact">
      <div className="max-w-4xl mx-auto px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 15 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-50px" }}
          className="text-center mb-16"
        >
          <span className="text-accent-orange font-bold text-[10px] tracking-[0.4em] uppercase mb-4 block italic">Get in Touch</span>
          <Heading className="text-5xl md:text-6xl font-serif font-bold text-white mb-6 uppercase tracking-tight">Contact <br /> Sandstorm Flix</Heading>
          <div className="w-20 h-1 bg-accent-orange mx-auto"></div>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 15 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-50px" }}
          transition={{ delay: 0.1 }}
          className="bg-white rounded-[3rem] p-8 md:p-16 shadow-2xl relative overflow-hidden"
        >
          <div className="absolute top-0 right-0 w-64 h-64 bg-accent-orange/5 rounded-full -translate-y-1/2 translate-x-1/2 blur-3xl"></div>
          
          <form className="space-y-8 relative z-10" onSubmit={handleSubmit}>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
              <div className="space-y-2">
                <label htmlFor="name" className="text-[10px] font-bold uppercase tracking-widest text-black/40 ml-4">Full Name</label>
                <input
                  id="name"
                  name="name"
                  type="text"
                  required
                  className="w-full bg-beige-light border-none rounded-full px-8 py-4 text-black outline-none focus:ring-2 focus:ring-accent-orange transition-all duration-500"
                  placeholder="Your Name"
                />
              </div>
              <div className="space-y-2">
                <label htmlFor="email" className="text-[10px] font-bold uppercase tracking-widest text-black/40 ml-4">Email Address</label>
                <input
                  id="email"
                  name="email"
                  type="email"
                  required
                  className="w-full bg-beige-light border-none rounded-full px-8 py-4 text-black outline-none focus:ring-2 focus:ring-accent-orange transition-all duration-500"
                  placeholder="your@email.com"
                />
              </div>
            </div>
            
            <div className="space-y-2">
              <label htmlFor="subject" className="text-[10px] font-bold uppercase tracking-widest text-black/40 ml-4">Inquiry Type</label>
              <select 
                id="subject"
                name="subject"
                className="w-full bg-beige-light border-none rounded-full px-8 py-4 text-black outline-none focus:ring-2 focus:ring-accent-orange appearance-none transition-all duration-500"
              >
                <option>New Feature Film</option>
                <option>Short Film / Digital</option>
                <option>Press & Media</option>
                <option>General Collaboration</option>
              </select>
            </div>

            <div className="space-y-2">
              <label htmlFor="message" className="text-[10px] font-bold uppercase tracking-widest text-black/40 ml-4">Project Details</label>
              <textarea
                id="message"
                name="message"
                rows="4"
                required
                className="w-full bg-beige-light border-none rounded-[2rem] px-8 py-6 text-black outline-none focus:ring-2 focus:ring-accent-orange transition-all duration-500 resize-none"
                placeholder="Tell us about your cinematic vision..."
              ></textarea>
            </div>

            <button
              type="submit"
              className="w-full bg-black text-white py-6 rounded-full font-bold uppercase tracking-[0.3em] flex items-center justify-center gap-3 hover:bg-accent-orange transition-all duration-500 shadow-xl group"
            >
              Send Message
              <SafeIcon icon={FiSend} className="w-5 h-5 group-hover:translate-x-2 group-hover:-translate-y-2 transition-transform" />
            </button>

            <div className="pt-8 border-t border-black/5 mt-8">
              <div className="flex items-center justify-center gap-4 text-black/40">
                <SafeIcon icon={FiPlay} className="w-6 h-6 text-accent-orange animate-pulse" />
                <p className="text-sm italic font-serif">"Tell me a story that hasn't been told yet."</p>
              </div>
            </div>
          </form>
        </motion.div>
      </div>
    </section>
  );
};

export default Contact;